import { contacts } from '../data/content';
import { SectionHeading } from './SectionHeading';

export function Contact() {
  return (
    <section className="section-band" id="contacts">
      <div className="container">
        <SectionHeading
          eyebrow="Contacts"
          title="Contact Information"
          text="Telegram, Discord, Instagram, Email, TikTok and Website."
        />

        <div className="contact-grid">
          {contacts.map((contact) => {
            const Icon = contact.icon;
            return (
              <a className="contact-card reveal" key={contact.label} href={contact.href} target="_blank" rel="noreferrer">
                <div className="card-icon">
                  <Icon size={21} />
                </div>
                <span>{contact.label}</span>
                <strong>{contact.value}</strong>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
